import { MultiSelect, MultiSelectOption } from "@/components/ui/multi-select";
import { UniversalContact } from "@/hooks/useUniversalContacts";
import { Label } from "@/components/ui/label";

interface EventAttendeesSelectorProps {
  contacts: UniversalContact[];
  selectedContactIds: string[];
  onSelectionChange: (selectedIds: string[]) => void;
  placeholder?: string;
}

export function EventAttendeesSelector({ 
  contacts, 
  selectedContactIds, 
  onSelectionChange,
  placeholder = "Sélectionner les participants"
}: EventAttendeesSelectorProps) {
  // Inclure tous les contacts, pas seulement ceux avec profile_id
  const selectableContacts = contacts;

  console.log('🔍 All contacts:', contacts.length);
  console.log('🔍 Selectable contacts:', selectableContacts.length);

  if (selectableContacts.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        <p>Aucun contact disponible</p>
      </div>
    );
  }

  // Utiliser l'ID de la person_profile comme valeur
  const options: MultiSelectOption[] = selectableContacts.map((contact) => {
    const personId = contact.originalData.id;
    const hasLinkedAccount = contact.source === 'family_member' 
      ? !!contact.profile_id 
      : !!contact.originalData.profile_id;
    
    return {
      value: personId,
      label: hasLinkedAccount ? contact.displayName : `${contact.displayName} (sans compte)`,
      avatar: contact.avatar_url,
      group: contact.source === 'family_member' || contact.originalData.category === 'family' 
        ? 'Famille' 
        : contact.originalData.category === 'friends' 
          ? 'Amis' 
          : 'Autre',
    };
  });

  console.log('🎯 Options generated:', options.map(o => ({ value: o.value, label: o.label })));
  console.log('🎯 Selected IDs:', selectedContactIds);

  return (
    <div className="space-y-2">
      <Label>Qui doit voir</Label>
      <MultiSelect
        options={options}
        selected={selectedContactIds}
        onChange={onSelectionChange}
        placeholder={placeholder}
      />
    </div>
  );
}